<template>
  <div class="flex items-center gap-2">
    <div
      class="w-4 h-4 flex-shrink-0 flex items-center justify-center rounded-full bg-gray"
    >
      <div class="rounded-full h-2 w-2 bg-black" />
    </div>
    <span class="leading-none">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'SurveyRadioOption',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>
